angular.module('bookAndPay').directive('ezidebitForm', function() {
  return {
    restrict: 'EA',
    template: require('templates/book_and_pay/ezidebit_form.html.slim'),
    scope: {
      cart: '=',
      months: '=',
      years: '=',
      currency: '=',
      fees: '=',
      expired: '=',
      toNewCart: '&',
      verifyCaptcha: '&',
      setLoading: '&'
    },
    controller: ["$scope", "$state", "$http", "$q", "$timeout", "CreditCardValidationService", "DataService", function($scope, $state, $http, $q, $timeout, CreditCardValidationService, DataService) {
      var cartType, initEzidebit, lock, onAuthenticationError, onPaymentDetailsSubmitReady, onSubmit, onSubmitError, submitPaymentResult, toggleLoading;
      $scope.id = Math.floor(Math.random() * 1000000);
      $scope.authToken = $('meta[name=csrf-token]').attr('content');
      $scope.gymName = DataService.gym_name;
      $scope.creditCard = {};
      cartType = $scope.cart.cart_type === 'payment_only_cart' ? 'po' : void 0;
      toggleLoading = function(val) {
        $scope.isLoading = val;
        return $scope.setLoading({
          loading: val
        });
      };
      initEzidebit = function() {
        return $timeout(function() {
          window.initEziDebit();
          return eziDebit.init($scope.publicKey, {
            submitAction: "ChargeCard",
            submitButton: `submit-ezidebit-payment-${$scope.id}`,
            submitCallback: onSubmit,
            submitError: onSubmitError,
            nameOnCard: "nameOnCard",
            cardNumber: "cardNumber",
            cardExpiryMonth: "expiryMonth",
            cardExpiryYear: "expiryYear",
            cardCCV: "ccv",
            paymentAmount: "paymentAmount",
            paymentReference: "paymentReference"
          }, $scope.cart.realtime_js_url);
        });
      };
      $scope.$watch('publicKey', function(key) {
        if (key && !$scope.cart.payment_processing_locked) {
          return initEzidebit();
        }
      });
      $scope.checkCardNumber = function() {
        var ref;
        $scope.creditCard.cardNumber = (ref = $scope.creditCard.cardNumber) != null ? ref.replace(/[^0-9]/g, '') : void 0;
        $scope.cardNumberValid = CreditCardValidationService.check($scope.creditCard.cardNumber);
        return $scope.errorMessage = !$scope.cardNumberValid && $scope.creditCard.showCardValidation ? 'Card number is invalid' : '';
      };
      $scope.onCardInputBlur = function() {
        $scope.creditCard.showCardValidation = true;
        return $scope.checkCardNumber();
      };
      onAuthenticationError = function() {
        if (window.Rollbar) {
          return window.Rollbar.error('Book and pay card authentication error', $scope.errorMessage);
        }
      };
      onSubmit = function(response) {
        return $timeout(function() {
          if (response.PaymentResult === 'F') {
            $scope.errorMessage = 'Failed. Payment was rejected by the bank.';
            toggleLoading(false);
            onAuthenticationError();
            return;
          }
          if (response.PaymentResult === 'U') {
            $scope.errorMessage = 'Payment cannot be submitted to the bank at this time. Please try again later.';
            toggleLoading(false);
            onAuthenticationError();
            return;
          }
          if (response.PaymentResult === 'A') {
            return submitPaymentResult(response.BankReceiptID);
          } else {
            if (window.Rollbar) {
              return window.Rollbar.error('Book and pay card authentication error', {
                message: 'Unknown error',
                data: response
              });
            }
          }
        });
      };
      submitPaymentResult = function(receiptId) {
        var params, url, uuid;
        uuid = $scope.cart.cart_uuid;
        url = `/websites/${window.DATA.domain}/book_and_pay/carts/${uuid}/handle_payment_result`;
        params = {
          payment_result: 'A',
          bank_receipt_id: receiptId
        };
        return $http.put(url, params).then(function(response) {
          toggleLoading(false);
          return $state.go('bookAndPay.complete', {
            uuid: $scope.cart.cart_uuid
          });
        }, function(response) {
          if (window.Rollbar) {
            window.Rollbar.error('Book and pay handle_payment_result error', response.data);
          }
          toggleLoading(false);
          return $scope.errorMessage = 'An unexpected error occurred. Please try again later.';
        });
      };
      onSubmitError = function(error) {
        return $timeout(function() {
          $scope.errorMessage = error;
          onAuthenticationError();
          return toggleLoading(false);
        });
      };
      $scope.onRecaptchaSubmitted = function(token) {
        var url, uuid;
        uuid = $scope.cart.cart_uuid;
        url = `/websites/${window.DATA.domain}/book_and_pay/carts/${uuid}/verify_ezidebit`;
        return $http.put(url, {
          recaptcha_token: token
        }).then(function(response) {
          $scope.publicKey = response.data.public_key;
          return $timeout(function() {
            return onPaymentDetailsSubmitReady();
          }, 100);
        }, function(response) {
          var ref, ref1;
          $scope.errorMessage = ((ref = response.data) != null ? ref.recaptcha_failure_message : void 0) || ((ref1 = response.data) != null ? ref1.error : void 0) || "Request could not be completed. Please try again";
          return toggleLoading(false);
        });
      };
      $scope.onRecaptchaError = function() {
        $scope.errorMessage = "Unable to perform CAPTCHA check. If enabled, consider disabling VPN / IP tracking software and try again.";
        return toggleLoading(false);
      };
      $scope.isReady = function() {
        return $scope.cardNumberValid && $scope.creditCard.cardholderName && $scope.creditCard.expirationMonth && $scope.creditCard.expirationYear && $scope.creditCard.ccv && !$scope.isLoading;
      };
      lock = function() {
        var deferred, url, uuid;
        if ($scope.cart.payment_processing_locked || $scope.paymentProcessingLocked) {
          deferred = $q.defer();
          deferred.resolve();
          return deferred.promise;
        } else {
          uuid = $scope.cart.cart_uuid;
          url = `/websites/${window.DATA.domain}/book_and_pay/carts/${uuid}/lock_payment_form`;
          return $http.put(url);
        }
      };
      $scope.onCardSubmitted = function() {
        if (!$scope.isReady()) {
          return;
        }
        toggleLoading(true);
        $scope.errorMessage = '';
        return $scope.$emit('recaptcha:execute');
      };
      onPaymentDetailsSubmitReady = function() {
        return lock().then(function() {
          $scope.paymentProcessingLocked = true;
          return angular.element(`#submit-ezidebit-payment-${$scope.id}`).click();
        }, function() {
          $scope.cart.payment_processing_locked = true;
          return toggleLoading(false);
        });
      };
      return $scope.cancel = function() {
        return $state.go('bookAndPay.newCart', {
          uuid: $scope.cart.membership_plan_uuid,
          ct: cartType
        });
      };
    }]
  };
});
